<script>
export default {
  props: {
    input: {
      type: String,
      default: () => ''
    },
    field: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    inputData: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      data: '',
      other: '',
      otherIsSelect: false
    }
  },
  computed: {
    hasOther() {
      return this.field.params.options.some(item => {
        return item.optionType === 'text'
      })
    }
  },
  watch: {
    inputData: {
      handler(v, ov) {
        this.setFromData()
      },
      deep: true
    },
    data: {
      handler(v, ov) {
        this.otherIsSelect = false;
        this.$emit('update:inputData', v)
      },
      deep: true
    },
  },
  mounted() {
    this.setFromData();
  },
  methods: {
    updataInput(value, type) {
      this.data = this.other !== '' ? '' : this.data;

      this.$nextTick(()=> {
        if(this.other !== '') {
          this.otherIsSelect = true;
        }else {
          this.otherIsSelect = false;
        }


        if(!(type === 'focus' && this.other === '')) {
          this.$emit('update:inputData', this.other);
        }

      });
    },
    setFromData() {
      this.$nextTick(() => {
        const isOther = this.field.params.options.every(item => {
          return (item.title !== this.inputData || this.inputData === '其他') && !!this.inputData
        });

        if(isOther) {
          if(this.inputData) {
            this.otherIsSelect = !!this.inputData;

            this.other = this.inputData;
          }
        }else {
          this.data = this.inputData;
        }
      });
    }
  },
  inject: ['$validator'],
}

</script>
<template>
  <b-field
    :message="errors.first(name)"
    :type="{ 'is-danger': errors.has(name) }"
    class="is-style-extrafield"
    :label="`${field.title} (${$t('global.SINGLE_SELECTION' /*單選*/)})`"
    :class="{ [$style['isRequired']]: field.required }"
  >
    <template v-for="(fieldOption, index) in field.params.options">
      <b-radio
        v-if="fieldOption.optionType === 'default'"
        :key="index"
        v-model="data"
        v-validate="{ required: Boolean(field.required) && !hasOther }"
        :data-vv-as="field.title"
        :name="name"
        :native-value="fieldOption.title">
        {{fieldOption.title}}
      </b-radio>
      <b-input
        v-if="fieldOption.optionType === 'text'"
        :key="index"
        v-model="other"
        v-validate="{ required: Boolean(field.required) }"
        :data-vv-as="field.title"
        :name="name"
        :placeholder="fieldOption.title"
        :class="{ 'hasText': otherIsSelect }"
        @input="updataInput(other, 'input')"
        @focus="updataInput(other, 'focus')"
      >
      </b-input>
    </template>
  </b-field>
</template>
<style lang="scss" module>
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
</style>
